<template>
  <div>
    <vx-card class="w-full">
      <div class="flex justify-between items-center">
        <h4>{{ boardLabel }} 엑셀 업로드</h4>
        <vs-button color="secondary" @click="onClickSave" :disabled="validation !== true">등록</vs-button>
      </div>

      <!-- 기본정보 -->
      <FieldSelectModule
        title="작성자 정보"
        v-model="form.stdInfo"
        :typeslabel="{
          date: '등록일',
        }"
        :board="board"
        :types="['department', 'com_name', 'rank', 'writer_name', 'date']"
        class="mt-28px"
      />

      <!-- 교육 정보 -->
      <div class="mt-28px">
        <div class="writeGridContainer">
          <div class="writeGridLineItem">
            <div>파일 업로드</div>
            <div class="flex flex-wrap gap-3">
              <vs-button color="secondary" type="border" :href="excelLink">엑셀 템플릿 다운로드</vs-button>
              <vs-button color="secondary" @click="onClickExcelUpload"> 작성 엑셀 업로드 </vs-button>
              <input v-show="false" ref="excelInput" type="file" multiple @change="onChangeReadFile" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-between items-center mt-28px mb-4">
        <h5><i class="dot"></i> 등록 대상 교육 정보</h5>
      </div>

      <div>
        <table class="excel-table">
          <colgroup>
            <col width="60" />
            <col width="60" />
            <col width="180" />
            <col/>
            <col/>
            <col/>
            <col width="70"/>
            <col/>
            <col/>
            <col/>
            <col width="160" />
          </colgroup>
          <thead>
          <tr>
            <th></th>
            <th>No.</th>
            <th v-for="head in heads" :key="head">
              {{
                head === 'inputA_1' ? 'ID(사번)' :
                head === 'name' ? '성명' :
                head === 'fieldOptions' ? '사업장명' :
                head === 'age' ? '연령' :
                head === 'gender' ? '성별' :
                head === 'workExperience' ? '현 직장경력' :
                head === 'workDepartment' ? '부서' :
                head === 'workLine' ? '라인' :
                head === 'workPerform' ? '작업' : head
              }}
            </th>
            <th>수정/삭제</th>
          </tr>
          </thead>
          <tbody v-for="(excel, excel_i) in excelData" :key="`${excel_i}_${excel[0]}`">
          <tr>
            <td class="text-center">
              <img src="@/assets/icons/triangle_down.svg" class="mx-auto duration-200" :style="{ transform: editingRowIndexes.includes(excel_i) ? 'rotate(0deg)' : 'rotate(-90deg)' }" />
            </td>
            <td class="text-center">{{ excel_i + 1 }}</td>
            <td v-for="head in heads" :key="`${excel_i}_td_${head}`">
              <!-- 현재 수정 중인 행 -->
              <div v-if="editingRowIndexes.includes(excel_i)" class="p-1">
                <employee-selector v-if="head === 'inputA_1'" v-model="editExcelData[excel_i].row[head]"
                                   :employee-id="editExcelData[excel_i].row[head]"
                                   @select="(data) => {onSelectEmployee(data, excel_i)}"/>
                <template v-else-if="head === 'fieldOptions'">
                  <div>
                    <multiselect :options="editExcelData[excel_i].row['fieldOptions']" v-model="editExcelData[excel_i].row['selectedField']" :multiple="false" placeholder="" selectLabel="" deselectLabel="" :showNoResults="false" :readonly="true">
                      <template slot="option" slot-scope="props">
                        <div>{{ props.option.label }}</div>
                      </template>
                      <!-- 선택된 옵션의 표시되는 내용 -->
                      <template slot="singleLabel" slot-scope="props">
                        <div style="font-size: 14px;">{{ props.option.label || '-' }}</div>
                      </template>
                      <!-- 선택할 수 있는 옵션이 없을 때 표시되는 내용 -->
                      <template slot="noOptions">
                        <div style="font-size: 14px;">-</div>
                      </template>
                    </multiselect>
                  </div>
                  <!--선택한 사업장이 없으면 에러를 표시한다-->
                  <div v-if="!editExcelData[excel_i].row['selectedField']" class="errMsg">사업장 선택 필요</div>
                </template>

                <!--성별 (종사자 데이터에 성별 정보가 없으므로 선택하도록 했음)-->
                <div class="flex" v-else-if="head === 'gender'">
                  <vs-select v-model="editExcelData[excel_i].row['gender']" autocomplete>
                    <vs-select-item text="남" value="남" />
                    <vs-select-item text="여" value="여"/>
                  </vs-select>
                </div>

                <!--라인 -->
                <div v-else-if="head === 'workLine'">
                  <ml-input v-model="editExcelData[excel_i].row[head]" class="w-full" />
                </div>

                <!-- 작업 -->
                <div v-else-if="head === 'workPerform'">
                  <ml-input v-model="editExcelData[excel_i].row[head]" class="w-full" />
                </div>

                <div v-else class="text-center w-full" >{{ editExcelData[excel_i].row[head] || "-" }}</div>
              </div>

              <!-- 수정하지 않는 행의 경우 -->
              <div v-else>
                <div class="flex items-center justify-center gap-2">
                  <div class="flex">
                    <span v-if="head === 'fieldOptions'" >{{ excel.row['selectedField'] ? excel.row['selectedField'].label : "-" }}</span>
                    <span v-else >{{ excel.row[head] || "-" }}</span>
                    <svg v-if="excel.err && excel.err[head]" style="margin-left:0.5rem;" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 17C13.9183 17 17.5 13.4183 17.5 9C17.5 4.58172 13.9183 1 9.5 1C5.08172 1 1.5 4.58172 1.5 9C1.5 13.4183 5.08172 17 9.5 17Z" fill="#FFDADA"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3 5.8C10.3 5.35817 9.94178 5 9.49995 5C9.05812 5 8.69995 5.35817 8.69995 5.8V9C8.69995 9.44183 9.05812 9.8 9.49995 9.8C9.94178 9.8 10.3 9.44183 10.3 9V5.8ZM9.49597 11.4C9.05634 11.4 8.69995 11.7582 8.69995 12.2C8.69995 12.6418 9.05634 13 9.49597 13H9.50393C9.94356 13 10.3 12.6418 10.3 12.2C10.3 11.7582 9.94356 11.4 9.50393 11.4H9.49597Z" fill="#EA5455"/>
                    </svg>
                  </div>
                </div>
                <p v-if="excel.err && excel.err[head]" class="errMsg">{{ excel.err[head] }}</p>
              </div>
            </td>
            <td>
              <div class="flex justify-center gap-3">
                <fragment v-if="editingRowIndexes.includes(excel_i)">
                  <button @click="onClickApplyRowData(excel_i)">
                    <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                  </button>
                  <button @click="onClickCancelRowData(excel_i)">
                    <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                  </button>
                </fragment>
                <fragment v-else>
                  <button @click="onClickEditExcelData(excel_i)">
                    <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                  </button>
                  <button @click="onClickRemoveExcelData(excel_i)">
                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                  </button>
                </fragment>
              </div>
            </td>
          </tr>

          <!--근골격계 증상조사표-->
          <tr v-if="editingRowIndexes.includes(excel_i) && editExcelData[excel_i].row['inputA_0'] && editExcelData[excel_i].row['selectedField'].value">
            <td colspan="12" class="p-4" style="background-color: #00000008">
              <div class="writeGridContainer mt-4">
                <div>
                  <div>결혼여부</div>
                  <div>
                    <vs-radio class="mr-4 donut-radio" v-model="editExcelData[excel_i].row.marriage" :vs-name="'marriage_'+excel_i" vs-value="미혼" color="secondary">미혼</vs-radio>
                    <vs-radio class="donut-radio" v-model="editExcelData[excel_i].row.marriage" :vs-name="'marriage_'+excel_i" vs-value="기혼" color="secondary">기혼</vs-radio>
                  </div>
                </div>
                <div></div>
                <div></div>

                <div>
                  <div>현재하고 있는 작업<br>(구체적으로)</div>
                  <div>
                    <ml-input v-model="editExcelData[excel_i].row.currentWork" class="w-full" />
                  </div>
                </div>

                <div>
                  <div>작업기간</div>
                  <div class="grid" style="grid-template-columns: 1fr auto 1fr auto; align-items: center;">
                    <ml-input v-model="editExcelData[excel_i].row.currentPeriod1" class="w-full" />
                    <span class="px-2">년</span>
                    <ml-input v-model="editExcelData[excel_i].row.currentPeriod2" class="w-full" />
                    <span class="px-2">개월</span>
                  </div>
                </div>
                <div></div>

                <div>
                  <div>1일 근무시간</div>
                  <div class="grid" style="grid-template-columns: 1fr auto; align-items: center;">
                    <ml-input v-model="editExcelData[excel_i].row.dayWorkTime" class="w-full" />
                    <span class="px-2">시간</span>
                  </div>
                </div>
                <div>
                  <div>근무 중 휴식시간<br>(식사시간 제외)</div>
                  <div class="grid" style="grid-template-columns: 1fr auto; align-items: center;">
                    <ml-input v-model="editExcelData[excel_i].row.dayRestTime1" class="w-full" />
                    <span class="px-2">분</span>
                  </div>
                </div>
                <div></div>

                <div>
                  <div>현작업을 하기 전에 했던 작업</div>
                  <div>
                    <ml-input v-model="editExcelData[excel_i].row.prevWork" class="w-full" />
                  </div>
                </div>
                <div>
                  <div>작업기간</div>
                  <div class="grid" style="grid-template-columns: 1fr auto 1fr auto; align-items: center;">
                    <ml-input v-model="editExcelData[excel_i].row.prevPeriod1" class="w-full" />
                    <span class="px-2">년</span>
                    <ml-input v-model="editExcelData[excel_i].row.prevPeriod2" class="w-full" />
                    <span class="px-2">개월</span>
                  </div>
                </div>
                <div></div>


              </div>
              <symptom-investigation-table class="mb-6" v-model="editExcelData[excel_i].row.symptomTable" :is-print="isPrint" :readonly="board.readonly" />
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import tabItems from "@/views/boards/tab/tab-items";

import XLSX from "xlsx";
import config from "/public/config";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import SymptomInvestigationTable from "@/views/boards/single-page/678/SymptomInvestigationTable.vue";
import EmployeeSelector from "@/components/selector/EmployeeSelector.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "PortExcelUpload",
  components: {
    EmployeeSelector,
    SymptomInvestigationTable,
    FieldSelector,
    FieldSelectModule,
    CompanySelector,
    Multiselect,
  },
  props:{
    isPrint: Boolean,
    board: Object,
    header: Object,
  },
  data() {
    return {
      tabItems,
      form: {
        stdInfo: {},
      },

      excelData: [],

      // 현재 수정 중인 행의 인덱스
      editingRowIndexes: [],
      editExcelData: [],

      employeeList: [],
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    boardId() {
      return this.$route.params.boardId;
    },
    boardLabel() {
      return this.tabItems[this.boardId].label;
    },
    myInfo() {
      return this.$store.state.member.memberInfo;
    },
    excelLink() {
      return `${config.BASE_API_URL}/storage/app/media/%EA%B7%BC%EA%B3%A8%EA%B2%A9%EA%B3%84%20%EC%A6%9D%EC%83%81%EC%A1%B0%EC%82%AC%ED%91%9C_%EC%95%88%EC%A0%84%EB%B3%B4%EA%B1%B4%EA%B4%80%EB%A6%AC%EC%8B%9C%EC%8A%A4%ED%85%9C_%EB%8C%80%EB%9F%89%EB%93%B1%EB%A1%9D.xlsx`;
    },
    heads () {
      // 엑셀을 읽올 때 사용한 keys 값을 사용한다. (this.onChangeReadFile 참고)
      return ["inputA_1", "name", "fieldOptions", "age", "gender", "workExperience", "workDepartment", "workLine", "workPerform"];
    },

    // 현재는 field list 를 읽어오는 구문이 없어서, 임시로 만들어 놓은 것이다.
    // 실제로는 created 가 호출 될 때, field list 를 읽어와야 한다.
    fieldNameList() {
      if (this.$store.state.project.fieldListInfo.data) {
        const list = [];
        for (const field of this.$store.state.project.fieldListInfo.data) {
          list.push(field.field_name);
        }

        return list;
      }

      return [];
    },
    validation () {
      if (this.excelData.length === 0) {
        return "엑셀 정보가 없습니다"
      } else {
        for (const excel of this.excelData) {

          if (excel['row']['selectedField'] === undefined) {
            return "사업장 정보가 없는 항목이 있습니다"
          }

          if (excel['row']['inputA_1'] === undefined) {
            return "종사자 정보가 연결되지 않은 항목이 있습니다"
          }

          if (Object.keys(excel.err).length > 0) {
            return "입력된 정보를 확인해주세요"
          }
        }
      }
      return true;
    },
    allCheck() {
      if (this.excelData.length > 0) {
        for (const excel of this.excelData) {
          if (!excel.isChecked) {
            return false;
          }
        }
      }
      return true
    },
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      await this.loadEmployeeList();
    },
    /**
     * 종사자가 목록을 조회한다.
     * @param page
     * @returns {Promise<void>}
     */
    async loadEmployeeList(page = 1) {
      // 500개씩 불러온다.
      const options = {
        page,
        perPage: 500,
        projectId: this.projectId,
      }
      const apiResponseData = await this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", options);
      this.employeeList = this.employeeList.concat(apiResponseData.data); //employee_id
      if (apiResponseData.last_page > page) {
        await this.loadEmployeeList(page + 1);
      }
    },
    onSelectEmployee(data, index) {
      const form = this.editExcelData[index].row
      form.inputA_0 = data.id;
      form.name = data.full_name;
      form.age = this.calculateAge(data.date_of_birth);
      form.gender = form.gender || "남";
      form.fieldNames = data.fields.map((field) => field.field_name);
      form.workExperience = this.calculateExperience(data.hire_date);
      form.workDepartment = data.company.com_name;
      form.fieldOptions = this.getEmployeeFieldOptions(data.fields);
      if ((form.fieldOptions || []).length === 1) {
        form.selectedField = form.fieldOptions[0];
      }

      this.$set(this.editExcelData, index, this.editExcelData[index]);
    },
    calculateAge(birthDate) {
      if (!birthDate) return '';

      // birthDate 를 Date 객체로 변환
      const birth = new Date(birthDate);
      const today = new Date();

      // 오늘 날짜와 생일의 차이를 계산 (단위: 년)
      let age = today.getFullYear() - birth.getFullYear();

      // 생일이 아직 오지 않았다면 나이에서 1을 뺌
      const m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
        age--;
      }

      // 계산된 만나이 반환
      return age;
    },

    calculateExperience(hireDate) {
      if (!hireDate) return '';

      // hireDate를 Date 객체로 변환
      const startDate = new Date(hireDate);
      const currentDate = new Date();

      // 현재 날짜와 시작 날짜의 차이를 계산 (단위: 월)
      let months = (currentDate.getFullYear() - startDate.getFullYear()) * 12;
      months -= startDate.getMonth();
      months += currentDate.getMonth();

      // 연도와 월로 변환
      const years = parseInt(months / 12);
      months %= 12;

      // 'yy년 mm개월' 형식의 문자열로 결과 반환
      return `${years}년/${months}개월`;
    },
    findEmployee(employee_id) {
      for (const employee of this.employeeList) {
        if (`${employee.employee_id}` === `${employee_id}`) {
          return employee;
        }
      }
      return null;
    },
    getFieldId(fieldName) {
      if (this.fieldList.length > 0) {
        for (const field of this.fieldList) {
          if (field.field_name === fieldName) {
            return field.id;
          }
        }
      }
      return 0
    },
    getFieldName(fieldId) {
      if (this.fieldList.length > 0) {
        for (const field of this.fieldList) {
          if (field.id === fieldId) {
            return field.field_name;
          }
        }
      }
    },

    onClickExcelUpload() {
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },
    onChangeReadFile(event) {
      this.readFile(event, (sheetData) => {
        const columns = [
          "B", "C", "D", "E", "F",
          "G", "H", "I", "J", "K",
          "L", "M", "N", "O", "P",

          "Q", "R", "S", "T",
          "U", "V", "W", "X", "Y",
          "Z", "AA", "AB", "AC", "AD", "AE",
          "AF", "AG", "AH", "AI", "AJ", "AK",
          "AL", "AM", "AN", "AO", "AP", "AQ",
          "AR", "AS", "AT", "AU", "AV",
          "AW", "AX", "AY", "AZ", "BA", "BB"
        ];

        const keys = [
          /* B */ 'inputA_1', 'name', 'age', 'gender', 'workExperience',
          /* G */ 'workDepartment', 'workLine', 'workPerform', 'marriage', 'currentWork',
          /* L */ '현재작업_작업기간', 'dayWorkTime', 'dayRestTime1', 'prevWork', '이전작업_작업기간',

          // form.symptomTable
          /* Q */ '여가및취미활동', '하루가사노동', '의사진단', '육체적부담정도',

          /* U */ '목_2', '목_3', '목_4', '목_5', '목_6',
          /* Z */ '어깨_1', '어깨_2', '어깨_3', '어깨_4', '어깨_5', '어깨_6',
          /* AF */ '팔_1', '팔_2', '팔_3', '팔_4', '팔_5', '팔_6',
          /* AL */ '손_1', '손_2', '손_3', '손_4', '손_5', '손_6',
          /* AR */ '허리_2', '허리_3', '허리_4', '허리_5', '허리_6',
          /* AU */ '다리_1', '다리_2', '다리_3', '다리_4', '다리_5', '다리_6',
        ];

        // 현재작업_작업기간 --> currentPeriod1(년), currentPeriod2(개월)
        // 이전작업_작업기간 --> prevPeriod1(년), prevPeriod2(개월)

        // form.symptomTable
        // 여가및취미활동 --> input1[%]
        // 하루가사노동 --> input2[%]
        // 의사진단 --> input3[%]
        // 육체적부담정도 --> input5[%]

        // form.symptomTable.input6 = '6|예'
        // 목_2 ~ 목_6 (index : 19 ~ 23) -->  input6_option2['목']
        // 어깨_1 ~ 어깨_6 (index : 24 ~ 29) --> input6_option2['어깨']
        // 팔_1 ~ 팔_6 (index : 30 ~ 35) --> input6_option2['팔']
        // 손_1 ~ 손_6 (index : 36 ~ 41) --> input6_option2['손']
        // 허리_2 ~ 허리_6 (index : 42 ~ 46) --> input6_option2['허리']
        // 다리_1 ~ 다리_6 (index : 47 ~ 51) --> input6_option2['다리']

        let rowIndex = 8;
        let rowData = [];
        do {
          rowData = this.getRowData(sheetData, rowIndex++, columns);
          if (!this.isEmptyRowData(rowData)) {
            const isChecked = false
            const row = {
              inputA_0: '',
              name: '',
              age: '',
              fieldNames: '',
              fieldOptions: [], // 종사자가 참여하고 있는 사업장 목록
              selectedField: { field_name: '', id: 0 }, // 선택된 사업장 정보
              workExperience: '',
              workDepartment: '',
              fieldId:0,

              symptomTable: {
                input1: ['6'],
                input2: {},
                input3: '',
                input3_option1: '',
                input3_option2: ['해당사항 없음'],
                input4: '',
                input4_option: [],
                input5: '',
                input6: '',
                input6_option1: [],
                input6_option2: {
                  '목': ['', '', '', '', '', []],
                  '어깨': ['', '', '', '', '', []],
                  '팔/팔꿈치': ['', '', '', '', '', []],
                  '손/손가락/손목': ['', '', '', '', '', []],
                  '허리': ['', '', '', '', '', []],
                  '다리/발': ['', '', '', '', '', []],
                },
                input6_option2_value: [
                  [0, 0, 0, 0, 0, []],
                  [0, 0, 0, 0, 0, []],
                  [0, 0, 0, 0, 0, []],
                  [0, 0, 0, 0, 0, []],
                  [0, 0, 0, 0, 0, []],
                  [0, 0, 0, 0, 0, []],
                ],
                input6_option2_result: ['', '', '', '', '', '']
              } }
            const options = [
              ['오른쪽', '왼쪽', '양쪽 모두'],
              ['1일 미만', '1일 - 1주일 미만', '1주일 - 1달 미만', '1달 - 6개월 미만', '6개월 이상'],
              ['약한 통증', '중간 통증', '심한 통증', '매우 심한 통증'],
              ['6개월에 1번', '2-3달에 1번', '1달에 1번', '1주일에 1번', '매일'],
              ['아니요', '예'],
              ['병원․한의원 치료', '약국치료', '병가, 산재', '작업 전환', '해당사항 없음'],
            ]

            const err = {}
            for (let i = 0; i < keys.length; i++) {
              const key = keys[i]

              if (i <= 14) {
                row[key] = rowData[i];

                if (i === 0) {
                  const employee = this.findEmployee(rowData[i]);
                  if (!employee) {
                    err[key] = "입력된 종사자가 검색되지 않습니다.";
                    err["fieldOptions"] = "사업장을 선택해주세요.";
                  } else {
                    row['inputA_0'] = employee.id;
                    row['fieldNames'] = employee.fields.map((field) => field.field_name);
                    row['fieldOptions'] = this.getEmployeeFieldOptions(employee.fields);
                    if (row['fieldOptions'].length === 1) {
                      row['selectedField'] = row['fieldOptions'][0];
                    }

                    // 엑셀 데이터와 DB 데이터가 겹치는 데이터
                    // 이 곳에 데이터를 처리하면, keys for 문이 모두 실행된 후에는 엑셀에 저장된 데이터로 덮어지게 된다.
                    // 만약, DB 데이터를 엑셀 데이터로 덮어쓰지 않으려면, keys for 문 이후에 처리해야 한다.
                    row['name'] = employee.full_name;
                    row['age'] = this.calculateAge(employee.date_of_birth);
                    row['workExperience'] = this.calculateExperience(employee.hire_date);
                    row['workDepartment'] = employee.company.com_name;

                    // 선택된 사업장이 있는지 검증한다
                    if (!row['selectedField'].value) {
                      err["fieldOptions"] = "사업장을 선택해주세요.";
                    }
                  }
                }

                if (key === 'gender') {
                  if (`${row[key]}` === '1') { row[key] = '남' }
                  if (`${row[key]}` === '2') { row[key] = '여' }
                }

                if (key === 'marriage') {
                  if (`${row[key]}` === '1') { row[key] = '기혼' }
                  if (`${row[key]}` === '2') { row[key] = '미혼' }
                }

                if (key === '현재작업_작업기간') {
                  const month = row[key];
                  if (month) {
                    const temp = `${month}`.split('.');
                    row['currentPeriod1'] = temp[0] || '0';
                    row['currentPeriod2'] = temp[1] ? Number(`${temp[1]}`) * 12 / 10.0 : '0';
                  }
                }

                if (key === '이전작업_작업기간') {
                  const month = row[key];
                  if (month) {
                    const temp = `${month}`.split('.');
                    row['prevPeriod1'] = temp[0] || '0';
                    row['prevPeriod2'] = temp[1] ? Number(`${temp[1]}`) * 12 / 10.0 : '0';
                  }
                }
              }

              // form.symptomTable
              else if (i < 19) {
                if (rowData[i]) {
                  if (i === 15) {
                    const data = `${rowData[i]}`.split(',')
                    row.symptomTable.input1 = data;
                  } else if (i === 16) {
                    const datas = ['거의 하지 않는다.', '1시간 미만', '1-2시간 미만', '2-3시간 미만', '3시간 이상']
                    const index = Number(`${rowData[i]}`)
                    const data = datas[index - 1]
                    row.symptomTable.input2 = data;
                  } else if (i === 17) {
                    // 3. 귀하는 의사로부터 다음과 같은 질병에 대해 진단을 받은 적이 있습니까?(해당 질병에 체크)
                  } else if (i === 18) {
                    const datas = ['전혀 힘들지 않음', '견딜만 함', '약간 힘듦', '힘듦', '매우 힘듦']
                    const index = Number(`${rowData[i]}`)
                    const data = datas[index - 1]
                    row.symptomTable.input5 = data;
                  }
                }
              } else if (i >= 19 && i <= 23) {
                if (rowData[i]) {
                  const key = '목'
                  const keyIndex = 0
                  const num = i - 19 + 1; // 2번 항목부터 시작
                  const optionNum = rowData[i] - 1;
                  if (num < 5) {
                    row.symptomTable.input6_option2[key][num] = `${key}-${num}|${options[num][optionNum]}`;
                    row.symptomTable.input6_option2_value[keyIndex][num] = rowData[i] || 0;
                  } else {
                    row.symptomTable.input6_option2[key][num].push(options[num][optionNum])
                    row.symptomTable.input6_option2_value[keyIndex][num].push(rowData[i])
                  }

                  if (row.symptomTable.input6_option1.indexOf(key) < 0) {
                    row.symptomTable.input6_option1.push(key)
                  }
                }
              } else if (i >= 24 && i <= 29) {
                if (rowData[i]) {
                  const key = '어깨'
                  const keyIndex = 1
                  const num = i - 24; // 1번 항목부터 시작
                  const optionNum = rowData[i] - 1;
                  if (num < 5) {
                    row.symptomTable.input6_option2[key][num] = `${key}-${num}|${options[num][optionNum]}`;
                    row.symptomTable.input6_option2_value[keyIndex][num] = rowData[i] || 0;
                  } else {
                    row.symptomTable.input6_option2[key][num].push(options[num][optionNum])
                    row.symptomTable.input6_option2_value[keyIndex][num].push(rowData[i])
                  }

                  if (row.symptomTable.input6_option1.indexOf(key) < 0) {
                    row.symptomTable.input6_option1.push(key)
                  }
                }
              } else if (i >= 30 && i <= 35) {
                if (rowData[i]) {
                  const key = '팔/팔꿈치'
                  const keyIndex = 2
                  const num = i - 30; // 1번 항목부터 시작
                  const optionNum = rowData[i] - 1;
                  if (num < 5) {
                    row.symptomTable.input6_option2[key][num] = `${key}-${num}|${options[num][optionNum]}`;
                    row.symptomTable.input6_option2_value[keyIndex][num] = rowData[i] || 0;
                  } else {
                    row.symptomTable.input6_option2[key][num].push(options[num][optionNum])
                    row.symptomTable.input6_option2_value[keyIndex][num].push(rowData[i])
                  }

                  if (row.symptomTable.input6_option1.indexOf(key) < 0) {
                    row.symptomTable.input6_option1.push(key)
                  }
                }
              } else if (i >= 36 && i <= 41) {
                if (rowData[i]) {
                  const key = '손/손가락/손목'
                  const keyIndex = 3
                  const num = i - 36; // 1번 항목부터 시작
                  const optionNum = rowData[i] - 1;
                  if (num < 5) {
                    row.symptomTable.input6_option2[key][num] = `${key}-${num}|${options[num][optionNum]}`;
                    row.symptomTable.input6_option2_value[keyIndex][num] = rowData[i] || 0;
                  } else {
                    row.symptomTable.input6_option2[key][num].push(options[num][optionNum])
                    row.symptomTable.input6_option2_value[keyIndex][num].push(rowData[i])
                  }

                  if (row.symptomTable.input6_option1.indexOf(key) < 0) {
                    row.symptomTable.input6_option1.push(key)
                  }
                }
              } else if (i >= 42 && i <= 46) {
                if (rowData[i]) {
                  const key = '허리'
                  const keyIndex = 4
                  const num = i - 42 + 1; // 2번 항목부터 시작
                  const optionNum = rowData[i] - 1;
                  if (num < 5) {
                    row.symptomTable.input6_option2[key][num] = `${key}-${num}|${options[num][optionNum]}`;
                    row.symptomTable.input6_option2_value[keyIndex][num] = rowData[i] || 0;
                  } else {
                    row.symptomTable.input6_option2[key][num].push(options[num][optionNum])
                    row.symptomTable.input6_option2_value[keyIndex][num].push(rowData[i])
                  }

                  if (row.symptomTable.input6_option1.indexOf(key) < 0) {
                    row.symptomTable.input6_option1.push(key)
                  }
                }
              } else if (i >= 47 && i <= 51) {
                if (rowData[i]) {
                  const key = '다리/발'
                  const keyIndex = 5
                  const num = i - 47;  // 1번 항목부터 시작
                  const optionNum = rowData[i] - 1;
                  if (num < 5) {
                    row.symptomTable.input6_option2[key][num] = `${key}-${num}|${options[num][optionNum]}`;
                    row.symptomTable.input6_option2_value[keyIndex][num] = rowData[i] || 0;
                  } else {
                    row.symptomTable.input6_option2[key][num].push(options[num][optionNum])
                    row.symptomTable.input6_option2_value[keyIndex][num].push(rowData[i])
                  }

                  if (row.symptomTable.input6_option1.indexOf(key) < 0) {
                    row.symptomTable.input6_option1.push(key)
                  }
                }
              }
            }

            if (keys.length > 0) {
              const employee = this.findEmployee(rowData[0]);
              if (employee) {
                // 엑셀 데이터를 DB 데이터로 덮어쓴다.
                row['name'] = employee.full_name;
                row['age'] = this.calculateAge(employee.date_of_birth);
                row['workExperience'] = this.calculateExperience(employee.hire_date);
                row['workDepartment'] = employee.company.com_name;
              }
            }

            row.symptomTable.input6 = row.symptomTable.input6_option1.length > 0 ? '6|예' : '6|아니오'

            this.excelData.push({ isChecked, row, err })
          }
        } while (!this.isEmptyRowData(rowData));
      });
    },
    // 엑셀데이터 파싱
    async readFile(event, callback) {
      // get File object from input tag
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        // declare FileReader, temp result
        const reader = new FileReader();
        const tmpResult = {};

        // if you use "this", don't use "function(e) {...}"
        reader.onload = async (e) => {
          let data = e.target.result;
          data = new Uint8Array(data);
          // get excel file
          const excelFile = XLSX.read(data, { type: "array", cellDates: true });
          const sheetData = excelFile.Sheets[excelFile.SheetNames[0]];

          if (callback) {
            callback(sheetData)
          }
        };
        reader.readAsArrayBuffer(file);
      }
    },

    getCellData(sheet, cell, key = "v") {
      // sheet[row]가 존재하고, 해당 cell 존재하는지 확인
      // sheet[cell].v : Raw value
      // sheet[cell].w : Formatted value
      // sheet[cell].t : Type
      if (sheet[cell] !== undefined) {
        return sheet[cell][key];
      } else {
        return "";
      }
    },
    getRowData(sheet, row, columns, key = "v") {
      const result = [];
      for (const col in columns) {
        const cell = columns[col] + row;
        if (sheet[cell] !== undefined) {
          result.push(sheet[cell][key]);
        } else {
          result.push("");
        }
      }
      return result;
    },
    isEmptyRowData(row) {
      for (const cell of row) {
        if (cell !== "") {
          return false;
        }
      }
      return true
    },

    // 종사자와 연결된 사업장 목록을 options로 반환
    getEmployeeFieldOptions(fields) {
      const options = [];
      for (const field of fields) {
        options.push({
          label: field.field_name,
          value: field.id,
        });
      }
      return options;
    },

    inputDetail(data) {
      this.editExcelData.form = data;
    },
    onClickEditExcelData(index) {
      this.editingRowIndexes.push(index);
      this.editExcelData[index] = JSON.parse(JSON.stringify(this.excelData[index]));
    },
    onClickRemoveExcelData(index) {
      this.excelData.splice(index, 1);
    },
    /**
     * 수정된 행 데이터를 저장한다.
     * @param index 행의 인덱스 (0부터)
     */
    onClickApplyRowData(index) {
      // 올바른 종사자가 연결됐는지 검증한다.
      if (!this.findEmployee(this.editExcelData[index].row["inputA_1"])) {
        this.editExcelData[index].err["inputA_1"] = "입력된 종사자가 검색되지 않습니다.";
      } else {
        delete this.editExcelData[index].err["inputA_1"];
      }

      // 올바른 사업장이 선택됐는지 확인한다.
      if (!(this.editExcelData[index].row.selectedField.value || 0)) {
        this.editExcelData[index].err["fieldOptions"] = "사업장을 선택해주세요.!";
      } else {
        delete this.editExcelData[index].err["fieldOptions"];
      }

      this.$set(this.excelData, index, this.editExcelData[index]);
      this.editingRowIndexes = this.editingRowIndexes.filter((i) => i !== index);
      this.editExcelData[index] = null;
    },
    /**
     * 수정된 행 데이터를 취소한다.
     * @param index 행의 인덱스 (0부터)
     */
    onClickCancelRowData(index) {
      this.editingRowIndexes = this.editingRowIndexes.filter((i) => i !== index);
      this.editExcelData[index] = null;
    },
    onClickSave() {
      // 엑셀 데이터가 없을때 에러
      if (this.excelData.length < 1) {
        this.$emit("customAlert", "엑셀 정보가 없습니다");
        return;
      }

      if (this.validation !== true) {
        this.$emit("customAlert", this.validation);
        return;
      }

      const posts = this.excelData.map((ed) => {
        const option = {
          ...this.form,
          ...ed.row,
          fieldId: ed.row.selectedField.value,
        };
        option.stdInfo.field_id = ed.row.selectedField.value || 0;
        option.stdInfo.field_name = ed.row.selectedField.label || "";
        return option;
      });

      this.$emit("save", {posts,
        callback: (success, data) => {
          if (success) {
          // 초기화
            this.excelData = [];
            this.editExcelData = [];
            this.editingRowIndexes = [];
          }
        }});
    },
    // 정렬 후 기타, 기타 외를 배열의 마지막으로 이동하는 함수
    setCatOther(list) {
      list.sort();

      const etcIndex = list.indexOf("기타");
      if (etcIndex > -1) {
        list.splice(etcIndex, 1);
        list.push("기타");
      }
      const etcOutIndex = list.indexOf("기타 외");
      if (etcOutIndex > -1) {
        list.splice(etcOutIndex, 1);
        list.push("기타 외");
      }

      return list;
    },
    // 일괄 체크
    onClickAllCheckbox() {
      if (this.allCheck) {
        if (this.excelData.length > 0) {
          for (const excel of this.excelData) {
            excel.isChecked = false
          }
        }
      } else if (this.excelData.length > 0) {
        for (const excel of this.excelData) {
          excel.isChecked = true
        }
      }
    },
    deleteRow() {
      if (this.excelData.length > 0) {
        this.excelData = this.excelData.filter((excel) => !excel.isChecked);
      }
    }
  },
};
</script>

<style scoped lang="scss">
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  thead {
    th {
      text-align: center;
    }
  }

  th,
  td {
    padding: 0;
  }

  th {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;

    background: #fafafa;
    border-top: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;

    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  .sub-table {
    th {
      background: #7e72f20d;
      border-top: 0;
      padding: 16px 10px;
    }
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }

  .check {
    justify-content: center !important;
    ::v-deep {
      span {
        margin: 0;
      }
    }
  }
}

.errMsg {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #ea5455;
  margin-top: 2px;
}

</style>
<style scoped>
/*라디오 버튼을 figma 시안과 동일하게 구현하기 위한 vs-radio 스타일 덮어쓰기*/
.donut-radio >>> .vs-radio--circle {
  border: 6px solid rgba(var(--vs-secondary), 1.0);
  background:  white;
  box-shadow: none;
}
</style>
